import { Auth } from 'aws-amplify';

/**
 * Sign out of Cognito
 */
export default function () {
    Auth.signOut()
        .then(() => {
            localStorage.clear();
            sessionStorage.clear();
        }).catch((err) => {
            console.error('err :>> ', err);
        });
}
